import React, { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { useLang } from "@/i18n";
import { Bell } from "@phosphor-icons/react";

const TONE = { warning: "bg-amber-500", destructive: "bg-red-500", success: "bg-emerald-500", info: "bg-blue-500" };

export function NotificationBell() {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const ref = useRef();

  const load = () => api.get("/notifications").then(({ data }) => setItems(data)).catch(() => {});
  useEffect(() => { load(); const id = setInterval(load, 30000); return () => clearInterval(id); }, []);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const titleFor = (n) => {
    switch (n.type) {
      case "start_day": return t("notif_start_day");
      case "pending_report": return t("notif_pending_report");
      case "followup_due": return `${n.count} ${t("notif_followup_due")}`;
      case "followup_overdue": return `${n.count} ${t("notif_followup_overdue")}`;
      case "approvals": return `${n.count} ${t("notif_approvals")}`;
      case "not_started": return `${n.count} ${t("notif_not_started")}`;
      case "pending_reports": return `${n.count} ${t("notif_pending_reports_n")}`;
      case "announcement": return n.title;
      default: return n.title || n.type;
    }
  };

  return (
    <div className="relative" ref={ref}>
      <button data-testid="notif-bell" onClick={() => setOpen(!open)} className="relative p-2">
        <Bell size={22} weight={open ? "fill" : "regular"} className="text-slate-600" />
        {items.length > 0 && (
          <span data-testid="notif-badge" className="absolute top-0 right-0 h-4 min-w-[16px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold grid place-items-center">
            {items.length}
          </span>
        )}
      </button>
      {open && (
        <div className="absolute right-0 mt-1 w-72 max-h-96 overflow-y-auto rounded-xl bg-white border border-slate-200 shadow-lg z-50" data-testid="notif-panel">
          <div className="px-4 py-2 border-b border-slate-100 font-head font-semibold text-sm">{t("notifications")}</div>
          {items.length === 0 && <p className="px-4 py-6 text-center text-sm text-slate-400">{t("no_notifications")}</p>}
          {items.map((n) => (
            <div key={n.id} className="flex items-start gap-3 px-4 py-3 border-b border-slate-100 last:border-0" data-testid={`notif-item-${n.type}`}>
              <span className={`mt-1.5 h-2.5 w-2.5 rounded-full shrink-0 ${TONE[n.tone] || "bg-slate-400"}`} />
              <div className="min-w-0">
                <p className="text-sm font-semibold text-slate-800">{titleFor(n)}</p>
                {n.body && <p className="text-xs text-slate-500">{n.body}</p>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
